import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';
import styles from './PageCountCarousel.module.css';

export const ArrowSlot = createComponent('div', {
  className: 'hidden md:flex'
});

export const Controls = createComponent('div', {
  className: 'relative z-10 flex items-center justify-center gap-lg'
});

export const MobileDots = createComponent('div', {
  className: 'flex md:hidden'
});

export const PageDot = createComponent<
  ElementWithProps<{ isCurrent: boolean }>
>('div', ({ isCurrent }) => ({
  className: cx(
    'size-[7px] rounded-round',
    isCurrent ? 'bg-background-primary' : 'bg-background-muted-subtle'
  )
}));

export const PageDots = createComponent('nav', {
  'aria-label': 'Pagination',
  className: 'hidden items-center justify-center gap-sm md:flex'
});

export const PaginationWrapper = createComponent('div', {
  className: 'flex flex-col items-center justify-center overflow-hidden'
});

export const Slide = createComponent('div', {
  className:
    'snap-start pl-lg first:pl-2xl last:pr-2xl md:pl-0 md:first:pl-0 md:last:pr-0'
});

export const Slides = createComponent('div', {
  className: `${styles.slides} flex max-w-full gap-0 overflow-x-auto overflow-y-hidden overscroll-x-contain scroll-smooth snap-x snap-mandatory pb-[2px] md:gap-xl`
});

export const Wrapper = createComponent('section', {
  className:
    'flex max-w-full flex-col gap-y-2xl overflow-visible pt-2xl md:px-4xl md:pt-0'
});
